export const userPermissions: Readonly<any> = {
    GrantAndRevokePrivileges: 'GrantAndRevokePrivileges',
    UpdateScript: 'UpdateScript',
    ManageTagTypes: 'ManageTagTypes',
    ManageTags: 'ManageTags',
    ConfigureTWCMSProvider: 'ConfigureTWCMSProvider',
    AddVersion: 'AddVersion',
    AddUser: 'AddUser',
    AddUserGroup: 'AddUserGroup',
    EditAdminConfiguration: 'EditAdminConfiguration'
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/constants/userPermissions.ts